import { render, staticRenderFns } from "./addDia.vue?vue&type=template&id=b9f745fe&scoped=true&"
import script from "./addDia.vue?vue&type=script&lang=js&"
export * from "./addDia.vue?vue&type=script&lang=js&"
import style0 from "./addDia.vue?vue&type=style&index=0&id=b9f745fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f745fe",
  null
  
)

export default component.exports